import { systemConst } from './../../consts/modules/system';
import Vue from 'vue'
import {Component} from './decorator';
import { appConst,menuRouteHelper } from '@/lib';

@Component
export class BaseMixins extends Vue {
    L(key: string, ...argus: string[]) {
        if (key) {
            let source = "";
            let keyArr = key.split('.');
            let resultKey = key;
            if(keyArr.length > 1){
                source = keyArr[0];
                keyArr.shift();
                resultKey = keyArr.join('.');
            }
            if(source != "" && window.basic.localization.localizationList[source]){
                return argus.length > 1? window.basic.localization.localize(resultKey, source, ...argus): window.basic.localization.localize(resultKey, source, argus);
            }else{
                let defaultSource = appConst.localization.defaultLocalizationSourceName;
                return argus.length > 1? window.basic.localization.localize(key, defaultSource, ...argus): window.basic.localization.localize(key, defaultSource, argus);
            }
        }
    }

    hasPermission(permissionName:string){
        return window.basic.auth.hasPermission(permissionName);
    }

    // get systemCode(){
    //     return this.$store.state.app.systemCode;
    // }


    
    get systemCode(){
        return this.$store.state.system.customersystemcode.systemCode;
    }
     systemCodeWithNoCategory(category: string){
        let list=[];
        if (!category) return [];
        this.systemCode[category].forEach(element => {
            if(element.value!="Category"){
                list.push(element)

            }
        });
        return list;
     }
    get tagNavList(){
        return this.$store.state.app.tagNavList;
    }

    getCodeListByCategory(category: string) {
        if (!category) return [];
        return this.systemCode[category];
    }

    back(needRefresh:boolean = true) { 
        let currentNavList = [...this.tagNavList];

        let backRoute = menuRouteHelper.historyBack(currentNavList,this.$route);
        if(backRoute){
            this.$store.commit('app/setTagNavList',currentNavList);
            //返回上一层后，主动刷新
            if(needRefresh){
                backRoute.params = Object.assign(backRoute.params, { actionCode: "refresh" });
            }
            
            this.$router.push(backRoute);
        }
    }

    getCodeDescription(category: string, codeValue: string, replaceCode: string = "") {
        let codeList = this.getCodeListByCategory(category);
        let code: any;
        if (codeList != null) {
            code = codeList.find((currentItem, index, array) => {
                return currentItem.value === codeValue;
            });
            if(code == undefined && replaceCode) {
                code = codeList.find((currentItem, index, array) => {
                    return currentItem.value === replaceCode;
                });
            }
        }
        return code == undefined ? "" : code.displayText;
    }
}